/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Members_Login_PromptInputs */



/**
* | output |
* | --- |
* | "Sign in to browse the members directory." |
*
* @param {Members_Login_PromptInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const members_login_prompt = /** @type {((inputs?: Members_Login_PromptInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Login_PromptInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Connectez-vous pour parcourir l'annuaire des membres.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Inicia sesión para explorar el directorio de miembros.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Entre para explorar o diretório de membros.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Accedi per sfogliare l'elenco dei membri.")
	return /** @type {LocalizedString} */ ("Sign in to browse the members directory.")
});